import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=8794ef58&scoped=true&"
import script from "./CreateDepartment.vue?vue&type=script&lang=ts&"
export * from "./CreateDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDepartment.vue?vue&type=style&index=0&id=8794ef58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8794ef58",
  null
  
)

export default component.exports